import { createAction } from 'redux-actions';

export const toggleWorkspacesSidebar = createAction<boolean>('TOGGLE_WORKSPACES_SIDEBAR');

export const toggleNotificationsSidebar = createAction<boolean>('TOGGLE_NOTIFICATIONS_SIDEBAR');

export const setActivePaymentStatusInAppState = createAction<boolean>('SET_ACTIVE_PAYMENT_STATUS');
